import { useState } from 'react'

import { Section } from '@factorialco/deprecated-design-system'
import { ProfileEmployeeTeamFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ProfileEmployeeData } from 'modules/profile/components/ProfileForm/types'
import AssingTeamsModal from 'modules/profile/components/Teams/AssignTeamsModal'
import TeamMemberships from 'modules/profile/components/Teams/TeamMemberships'

interface Props {
  employeeData: ProfileEmployeeData
  isCurrentEmployee: boolean
  teams: ProfileEmployeeTeamFragment[]
  canManageTeams: boolean
}

const Teams = ({ employeeData, isCurrentEmployee, teams, canManageTeams }: Props) => {
  const [teamsModal, setTeamsModal] = useState(false)

  const onClickTeamsModal = () => {
    setTeamsModal(true)
  }

  const onCloseTeamsModal = () => {
    setTeamsModal(false)
  }

  return (
    <>
      <Section
        illustration="group"
        title={i18n.t('employee_form.teams')}
        description={i18n.tCurrent('employee_form.teams_info', isCurrentEmployee)}
        action={
          canManageTeams && teams.length > 0 && employeeData.active
            ? {
                label: i18n.t('employee_form.teams_info.assign_teams'),
                onClick: onClickTeamsModal,
              }
            : undefined
        }
      >
        <TeamMemberships
          teamMemberships={employeeData.memberships}
          canManageTeams={canManageTeams}
          isTerminated={!employeeData.active}
        />
      </Section>
      {teamsModal && canManageTeams && teams.length > 0 && (
        <AssingTeamsModal
          employeeMemberships={employeeData.memberships}
          employeeId={employeeData.id}
          authorizedTeams={teams}
          onCloseTeamsModal={onCloseTeamsModal}
        />
      )}
    </>
  )
}

export default Teams
